import { C } from '../theme'
import { useContent } from '../content/ContentContext'

export function Donate() {
  const donate = useContent().home.donate ?? {}

  return (
    <section id="donar" aria-label={donate.title ?? 'Donar'} className="sec" style={{ position: 'relative', padding: '104px 40px', background: C.red, color: '#fff5f2', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, opacity: 0.14, background: 'radial-gradient(circle at 82% 18%, #fff 0%, transparent 46%)' }} />
      <div style={{ position: 'relative', maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.goldSoft, marginBottom: 18 }}>
          {donate.eyebrow}
        </div>
        <h2 className="section-title" style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 46, lineHeight: 1.08, margin: '0 0 16px', letterSpacing: '-.01em' }}>
          {donate.title}
        </h2>
        <p style={{ fontSize: 16.5, lineHeight: 1.72, color: 'rgba(255,245,242,.92)', margin: '0 auto 30px', maxWidth: 580 }}>
          {donate.body}
        </p>
        {donate.ctaLabel && (
          <a className="btn" href="#contacto" style={{ display: 'inline-block', background: '#fff', color: C.red, fontWeight: 800, fontSize: 15, padding: '16px 36px', borderRadius: 3, textDecoration: 'none' }}>
            {donate.ctaLabel}
          </a>
        )}
      </div>
    </section>
  )
}
